import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromJobLocationState from './job-location.reducer';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromJobLocationState.jobLocationFeatureKey,
			fromJobLocationState.reducer
		),
	],
})
export class JobLocationStateModule {}
